import {Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot }  from '@angular/router';
import { UserInformationService } from '../common/services/user-information.service';
import { Observable } from 'rxjs/Rx';
import {MainComponent} from './main.component';

@Injectable()
export class MainResolver implements Resolve<MainComponent>
{
    constructor(private userInformationService: UserInformationService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return Observable.forkJoin(this.userInformationService.getCurrentUserPhoto(),
            this.userInformationService.getCurrentUser(),
            this.userInformationService.getCurrentUserMenu()
        );
    }
}
